// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "BOMVersion"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      type: "button",
      button: {
        type: "text"
      },
      thStyle: { width: "60px" }
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    { key: 'BOMId', label: 'BOM编码', sortable: true },
    {
      key: 'Name', label: 'BOM版本名称', sortable: true, thStyle: { width: "18rem" },
      width: "18rem"
    },
    { key: 'ItemId', label: '物料编号', sortable: true },
    {
      key: 'NameAlias', label: '物料名称', sortable: true, thStyle: { width: "12rem" },
      width: "12rem",
      type: "short"
    },
    // { key: 'FromDate', label: '开始日期', sortable: true },
    // { key: 'ToDate', label: '结束日期', sortable: true },
    // { key: 'Approved', label: '已批准', sortable: true },
    { key: 'FromQty', label: '最小批量', sortable: true },
    { key: 'create_by_username', label: '创建人', sortable: true },
    { key: 'create_at', label: '创建时间', sortable: true, type: "date" },
    { key: 'Active', label: '有效', sortable: true, type: "boolean" },
    { key: 'is_approved', label: '审批', sortable: true, type: "boolean" },
    {
      key: 'approved_by_username', label: '审批人', sortable: true,
      formatter: (value, key, item) => {
        if (item.is_approved) {
          return item.approved_by_username
        } else {
          return ""
        }
      }
    },
    { key: 'LastAsyncDate', label: '最近同步时间', sortable: true, type: "datetime" },
    // { key: 'SEI_Active_Approver', label: '启用人', sortable: true },

  ],
  invent_price: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      type: "button",
      button: {
        type: "text"
      },
      thStyle: { width: "60px" }
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      required: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    { key: 'ItemId', label: '物料编号', sortable: true, required: true },
    { key: 'NameAlias', label: '物料名称', sortable: true },
    { key: 'ReferenceNum', label: '参考价格', sortable: true },
    { key: 'price', label: '报价计算成本价格', type: "number", sortable: true, required: true },
    { key: 'create_by_username', label: '创建人', sortable: true },
    { key: 'create_at', label: '创建时间', sortable: true, type: "date" },
    { key: 'update_by_username', label: '修改人', sortable: true },
    { key: 'update_at', label: '修改时间', sortable: true, type: "date" },
  ]
}

const dataForm = {}

///前端验证
const rules = {}
const methods = {
  ///get
  async getData(_params) {
    let version_biz_data = new biz_data_helper.base_entity_helper(
      "get_bom_version_by_searchtext",
      {},
      {}
    )
    let f = _.map(fields.default, "key")
    let result = await version_biz_data
      .execAction({
        params: _params,
        fields: f
      }).run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async getDataBySql(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "get_bom_by_searchtext",
      {},
      {}
    )
    let result = await item_biz_data
      .execAction({
        params: _params,
        fields: _.map(fields.default, "key")
      }).run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveDataBomVersion(params) {
    let _actions = []
    for (var k in params) {
      if (k == "add") {
        _actions.push(
          biz_data.insertAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "edit") {
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "valid") {
        if (params.action_state) {
          const ensure_active_biz_data = new biz_data_helper.base_entity_helper("bom_uniq_active", {}, {})
          _actions.push(
            ensure_active_biz_data.execAction({
              params: params[k],
              fields: _.map(fields.default, "key")
            }).action({})
          )
        }
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "delete") {
        _actions.push(
          biz_data.removeAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "approved") {
        _actions.push(
          biz_data.approveAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        )
      }
      else if (k == "copy") {
        const copy_biz_data = new biz_data_helper.base_entity_helper("copy_bom", {}, {})
        _actions.push(
          copy_biz_data.execAction({
            params: params[k],
            fields: []
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      if (params.valid) {
        return result.data.BatchResult.Actions[1].Result.Data[0]
      }
      return result.data.BatchResult.Actions[0].Result.Data[0]
    } else {
      return null
    }
  },
  //获取同步数据
  async getAsyncData(_params) {
    let item_biz_data = new biz_data_helper.base_entity_helper(
      "ax_bom_or_route",
      {},
      {}
    )
    let result = await item_biz_data
      .handlerScriptAction({
        params: _params
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //同步数据到AX
  async asyncDataToAX(_params, vm) {
    let _actions = []
    const h_biz_data = new biz_data_helper.base_entity_helper(
      "interface_invoke",
      {},
      {}
    )
    const x_biz_data = new biz_data_helper.base_entity_helper(
      "checkinterfaceresult",
      {},
      {}
    )

    let company_params = _.groupBy(_params, "dataAreaId")
    for (var key in company_params) {
      let dt = company_params[key]
      _.each(dt, (t) => { delete t.dataAreaId })
      let _p = {
        company: key,
        method: "CMBOMRouteCreate",
        jsonData: dt
      }
      _actions.push(
        h_biz_data.handlerAction({
          params: _p
        }).action({
          output_last_item_map: {
            status: "ax_interface_status"
          }
        })
      )
      _actions.push(
        x_biz_data.checkAction({
          params: {}
        }).action({
          rollback_when: {
            ax_interface_status: {
              "<>": 0
            }
          }
        })
      )
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {

      ///判定AX执行结果
      let _rt = _.filter(result.data.BatchResult.Actions, {
        Code: "data/x/checkinterfaceresult"
      })
      let _rdata = _.filter(result.data.BatchResult.Actions, {
        Code: "data/h/interface_invoke"
      })
      let _is_ok = true
      _.each(_rt, t => {
        if (t.Result && t.Result.Rollback == true) {
          _is_ok = false
        }
      })
      if (_is_ok == true) {
        return {
          state: true,
          data: result.data.BatchResult.Actions,
          message: ""
        }
      } else {
        let _msg = ""
        _.each(_rdata, t => {
          if (
            !_.isNull(t.Result) &&
            t.Result.LastItem.ax_interface_status != 0
          ) {
            _msg = vm.$t("notify.ax_error") + "：" + t.Result.Data[0][0].message
          }
        })
        return {
          state: false,
          data: [],
          message: _msg
        }
      }
    } else {
      return null
    }
  },
  ///查询物料价格
  async getDataInventPrice(_params) {
    const ip_biz_data = new biz_data_helper.base_entity_helper("get_sales_quote_invent_price", {}, {})
    let result = await ip_biz_data.execAction({
      params: _params,
      fields: _.map(fields.invent_price, "key")
    }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveDataInventPrice(params) {
    let f = _.map(fields.invent_price, "key")
    f.push("create_by")
    f.push("update_by")
    f.push("deleted_by")
    const ip_biz_data = new biz_data_helper.base_entity_helper("InventPrice", {}, {})
    let _actions = []
    for (var k in params) {
      if (k == "add") {
        if (params["remove"]) {
          _actions.push(
            ip_biz_data.removeAction({
              params: params["remove"],
              fields: f
            }).action({})
          )
        }
        _actions.push(
          ip_biz_data.insertAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      if (k == "edit") {
        _actions.push(
          ip_biz_data.updateAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
      if (k == "delete") {
        _actions.push(
          ip_biz_data.removeAction({
            params: params[k],
            fields: f
          }).action({})
        )
      }
    }
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data[0]
    } else {
      return null
    }
  },
}
export { biz_data, dataForm, fields, methods, rules };

